<template lang="pug">
  .remove-step-button(@click="$emit('click')")
    f7-icon(f7="trash" size="14")
    label このSTEPを削除
</template>

<style lang="scss" scoped>
.remove-step-button {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

label {
  @extend %body-text;
  margin-left: 4px;
}
</style>

<script>
export default {}
</script>
